export default "__VITE_ASSET__DrbaSyuA__"